export const API_ROUTES = {
  // PRODUCT
  WATCHES: {
    GET_ALL: "/public/product/all",
    GET_DETAILS: (product_id) => `/public/product/${product_id}/detail`,
    GET_RELATED_WATCHES: (product_id) =>
      `/public/product/${product_id}/related`,
    GET_PRODUCT_TAGS: "/product/tag/options"
  },

  // PRODUCT FILTER
  BRAND: {
    // The public list. /brand/options returns every brand ever entered,
    // including ones whose watches are all sold, which put brands in the nav
    // and the A-Z directory whose collection page then read "0 timepieces
    // available".
    GET_OPTIONS: "/public/brand/options",
  },

  MODEL: {
    GET_OPTIONS: "/model/options",
    GET_FEATURED: "/model/featured",
  },

  BAND: {
    GET_OPTIONS: "/product-band/options/all",
  },

  BAND_DESCRIPTION: {
    GET_OPTIONS: "/product-band-description/options/all",
  },

  CASE: {
    GET_OPTIONS: "/product-case/options/all",
  },

  CASE_DIAMETER: {
    GET_OPTIONS: "/product-case-diameter/options/all",
  },

  DIAL: {
    GET_OPTIONS: "/product-dial/options/all",
  },

  DIAL_NUMERAL: {
    GET_OPTIONS: "/product-dial-numeral/options/all",
  },

  MOVEMENT: {
    GET_OPTIONS: "/product-movement/options/all",
  },

  CALIBER: {
    GET_OPTIONS: "/product-caliber/options/all",
  },

  YEAR: {
    GET_OPTIONS: "public/product/year",
  },
};
